export default "__VITE_ASSET__28b920a5__"